import tagConstants from '../constants/tag.constant';
import tagServices from '../services/tag.service';
import { generalErrorHandler, resetAbortController } from './utils';

function getStockTags(forceRefresh?: boolean) {
  return dispatch => {
    dispatch(request());
    const ac = resetAbortController(tagConstants.TAG_REQUEST);

    return tagServices.getStockTags(forceRefresh, ac.signal).then(
      ({ tags, stocksByTag }) => {
        dispatch(success(tags, stocksByTag));
      },
      generalErrorHandler(dispatch, error =>
        dispatch(failure(error.toString()))
      )
    );
  };

  function request() {
    return { type: tagConstants.TAG_REQUEST };
  }
  function success(tags, stocksByTag) {
    return { type: tagConstants.TAG_SUCCESS, tags, stocksByTag };
  }
  function failure(error) {
    return { type: tagConstants.TAG_FAILURE, error };
  }
}

const selectTag = (tagId: string) => {
  return { type: tagConstants.SELECT_TAG, tagId };
};

export default {
  getStockTags,
  selectTag,
};
